import { IconButton, Tooltip } from '@mui/material';
import { CircleHelp } from 'lucide-react';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { APIType } from '~/backend/types';
import { Features } from '~/components/FeatureToggle';
import AboutTabModal from '~/components/Modal/AboutTabModal';
import { TabItem } from '~/components/Modal/TabModal';
import { WorkflowTypes } from '~/state/atoms/viewerAtoms';
import AppConfig from '~/utils/appconfig';
import AboutContent from './AboutContent';

export default function About() {
    const intl = useIntl();
    const [modalState, setModalState] = useState({
        open: false,
        page: WorkflowTypes.WORKSPACE,
    });

    const products = [
        {
            name: 'Workspace+',
            description: <FormattedMessage id="workspacePlusDescription" />,
            content: <AboutContent apiType={APIType.WORKSPACE} />,
            type: WorkflowTypes.WORKSPACE,
        },
        AppConfig.isFeatureEnabled(Features.CONTOUR_WORKFLOW) && {
            name: 'Contour+',
            description: <FormattedMessage id="contourPlusDescription" />,
            content: <AboutContent apiType={APIType.CONTOURING} />,
            type: WorkflowTypes.CONTOUR,
        },
        AppConfig.isFeatureEnabled(Features.DOSE_WORKFLOW) && {
            name: 'Dose+',
            description: <FormattedMessage id="dosePlusDescription" />,
            content: <AboutContent apiType={APIType.DOSE} />,
            type: WorkflowTypes.DOSE,
        },
        AppConfig.isFeatureEnabled(Features.ADAPT_WORKFLOW) && {
            name: 'Adapt+',
            description: <FormattedMessage id="adaptPlusDescription" />,
            content: <AboutContent apiType={APIType.REGISTRATION} />,
            type: WorkflowTypes.ADAPT,
        },
        AppConfig.isFeatureEnabled(Features.IMAGE_TRANSLATION_WORKFLOW) && {
            name: 'Image+',
            description: <FormattedMessage id="imagePlusDescription" />,
            content: <AboutContent apiType={APIType.TRANSLATION} />,
            type: WorkflowTypes.IMAGE,
        },
    ].filter(Boolean) as TabItem[];

    return (
        <>
            <Tooltip title={<FormattedMessage id="about" />} placement="left">
                <IconButton
                    aria-label={intl.formatMessage({ id: 'about' })}
                    aria-haspopup="true"
                    onClick={() =>
                        setModalState((state) => ({ ...state, open: true }))
                    }
                    data-testid="about-button"
                    size="small"
                >
                    <CircleHelp size={18} />
                </IconButton>
            </Tooltip>
            <AboutTabModal
                open={modalState.open}
                setOpen={(open) =>
                    setModalState((state) => ({ ...state, open }))
                }
                items={products}
                selectedPage={modalState.page}
                setSelectedPage={(page) =>
                    setModalState((state) => ({
                        ...state,
                        page: page as WorkflowTypes,
                    }))
                }
            />
        </>
    );
}
